import styled from 'styled-components';
import { Radio as AntRadio } from 'antd';

export const StyledRadio = styled(AntRadio)``;

export const StyledRadioGroup = styled(AntRadio.Group)`
    & .ant-radio-checked .ant-radio-inner {
        border-color: var(--brand-6);
    }
    & .ant-radio-checked .ant-radio-inner::after {
        background-color: var(--brand-6);
    }
    & .ant-radio-wrapper:hover .ant-radio-inner {
        border-color: var(--brand-6);
    }
`;
